import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopbarComponent } from '../../../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../../../shared/components/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    TopbarComponent,
    SidebarComponent,
    CommonModule,
    RouterOutlet
  ],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {
  
  constructor() { }

  ngOnInit(): void {
  }
}